import { useQuery } from '@tanstack/react-query'
import { fetchEvolutionReportUrl } from '~/services/evolutionReport'
import { IEvolutionReportUrl, IFetchEvolutionReportUrlParams } from '~/interfaces'
import { ForbiddenError, HttpStatusCode, NotFoundError, UnexpectedError } from '~/protocols/http'
import { message } from '~/services'
import { hasObjectValue } from '~/utils'

const UNIQUE_KEY = 'evolutionReport'

type ErrorType = Error | NotFoundError | UnexpectedError

export const useEvolutionReport = (fetchParams: IFetchEvolutionReportUrlParams | null) => {
  const hasFetchParams = hasObjectValue({ ...fetchParams })

  const fetcher = async () => {
    if (!fetchParams) throw new Error('fetchParams is required')

    try {
      const response = await fetchEvolutionReportUrl(fetchParams)

      return response
    } catch (error: any) {
      if (typeof error === 'string') throw new Error(error)
      if (error?.status === HttpStatusCode.notFound) throw new NotFoundError(message('patient.not_found'))
      if (error?.status === HttpStatusCode.forbidden) throw new ForbiddenError(message('patient.forbidden'))

      throw new UnexpectedError(message('patient.unexpected_error'))
    }
  }

  return useQuery<IEvolutionReportUrl, ErrorType>([UNIQUE_KEY, fetchParams], fetcher, {
    enabled: hasFetchParams,
    cacheTime: Infinity,
    staleTime: Infinity
  })
}
